import {env} from '../utils/commons'
let platformInstance
export const getPlatformInstance = params => {
    return new Promise((resolve, reject) => {
        if (platformInstance) {
            resolve(platformInstance)
        }else{
            let platform
            if (env.wechat) platform = 'platformWechat'
            else if (env.dingtalk) platform = 'platformDingtalk'
            else if (env.welink) platform = 'platformWelink'
            else if (env.zhuoyun) platform = 'platformZhuoyun'
            else if (env.toon) platform = 'platformToon'
            else if (env.app) platform = 'platformApp'
            else platform = 'platformCommon'
            console.log(platform)
            import(/* webpackChunkName: "[request]", webpackInclude: /platform[A-Z]/ */ `./${platform}`)
                .then(({default: PlatformClass}) => {
                    platformInstance = new PlatformClass(params)
                    resolve(platformInstance)
                })
        }
    })
}